import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import Select from "../../../components/form/Select/Select";
import {DatabaseLongTermRetentionPeriod} from "~/client/resources/databaseLongTermRetentionPeriod";
import {BooleanRadioButton, BooleanRadioButtonGroup} from "@octopusdeploy/design-system-components";
import * as React from "react";
import {DataBaseComponent, DataBaseComponentState, Errors} from "~/components/DataBaseComponent";
import {BusyState} from "~/components/BusyFromPromise/BusyFromPromise";
import {HostedInstanceResource} from "~/client/resources/hostedInstanceResource";
import {HostedInstanceConfigureDatabaseBackupRetentionRequest} from "~/client/resources/HostedInstanceConfigureDatabaseBackupRetentionRequest";
import repository from "~/client/repository";

interface ChangeBackupRetentionDialogProps {
    errors: Errors;
    busy: BusyState;
    instance: HostedInstanceResource;
    onSaveClick(instance: HostedInstanceResource): void;
}

interface ChangeBackupRetentionDialogState extends DataBaseComponentState {
    databaseBackupRetentionRequest : Partial<HostedInstanceConfigureDatabaseBackupRetentionRequest>
}

export class ChangeBackupRetentionDialog extends DataBaseComponent<ChangeBackupRetentionDialogProps, ChangeBackupRetentionDialogState> {
    constructor(props: ChangeBackupRetentionDialogProps) {
        super(props);
        this.state = {
            databaseBackupRetentionRequest: {
                RetentionPeriod: props.instance.DatabaseBackupWeeklyLongTermRetention,
                RunDuringOutageWindow: true
            }
        }
    }

    render()
    {
        return <SaveDialogLayout title={"Change Backup Retention"}
                                 errors={this.state.errors}
                                 busy={this.state.busy}
                                 onSaveClick={() => this.configureBackupRetention(this.state.databaseBackupRetentionRequest)}>

            <Select value={this.state.databaseBackupRetentionRequest.RetentionPeriod}
                    onChange={val => {
                        const RetentionPeriod = val as DatabaseLongTermRetentionPeriod
                        this.updateDatabaseBackupRetentionRequest({RetentionPeriod});
                    }}
                    items={[
                        {
                            text: ChangeBackupRetentionDialog.getBackupRetentionDisplay(DatabaseLongTermRetentionPeriod.NinetyDays),
                            value: DatabaseLongTermRetentionPeriod.NinetyDays
                        },
                        {
                            text: ChangeBackupRetentionDialog.getBackupRetentionDisplay(DatabaseLongTermRetentionPeriod.ThreeYears),
                            value: DatabaseLongTermRetentionPeriod.ThreeYears
                        }
                    ]}
                    fieldName="Retention Duration"
                    hintText="How long weekly LTR backups will be retained"
            />
            <BooleanRadioButtonGroup value={this.state.databaseBackupRetentionRequest.RunDuringOutageWindow}
                                     onChange={scaleDuringOutageWindow => this.updateDatabaseBackupRetentionRequest({RunDuringOutageWindow: scaleDuringOutageWindow})}>
                <BooleanRadioButton value={true} label="Run During Outage Window" isDefault={true}/>
                <BooleanRadioButton value={false} label="Run Immediately"/>
            </BooleanRadioButtonGroup>
        </SaveDialogLayout>;
    }

    private updateDatabaseBackupRetentionRequest(update: Partial<HostedInstanceConfigureDatabaseBackupRetentionRequest>) {
        return this.setState(prevState => ({databaseBackupRetentionRequest: {...prevState.databaseBackupRetentionRequest, ...update}}));
    }

    private configureBackupRetention(request: Partial<HostedInstanceConfigureDatabaseBackupRetentionRequest>) {
        return this.doBusyTask(async () => {
            const instance = await repository.HostedInstances.configureBackupRetention(this.props.instance, request as HostedInstanceConfigureDatabaseBackupRetentionRequest);
            this.props.onSaveClick(instance);
            return true;
        });
    }
    
    public static getBackupRetentionDisplay(retention: DatabaseLongTermRetentionPeriod) {
        const durations = new Map<DatabaseLongTermRetentionPeriod, string>([
            [DatabaseLongTermRetentionPeriod.NinetyDays, "90 days"],
            [DatabaseLongTermRetentionPeriod.ThreeYears, "3 years"],
        ]);
        return durations.get(retention);
    }
}
